import React, { useState, useEffect } from 'react';
import { useSuppliers } from '../../hooks/useSuppliers';
import { supplierForOrder } from '../../utils/supplierOffers';

// Leverandørlogo. Uten lenke, eller når bildet ikke laster, vises fallback (standard ingenting).
export default function SupplierLogo({ logoUrl, fallback = null, size = 20 }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [logoUrl]);
  if (!logoUrl || failed) return fallback;
  return (
    <img
      src={logoUrl}
      alt=""
      onError={() => setFailed(true)}
      style={{ width: size, height: size, objectFit: 'contain', borderRadius: 4, background: '#fff', flexShrink: 0, verticalAlign: 'middle' }}
    />
  );
}

// Logoen til leverandøren et oppdrag hentes hos. Ingenting når leverandør eller logo mangler.
export function OrderSupplierLogo({ order, size = 16, style }) {
  const suppliers = useSuppliers();
  const logoUrl = supplierForOrder(order, suppliers)?.logoUrl;
  if (!logoUrl) return null;
  return (
    <span style={{ display: 'inline-flex', marginRight: 6, ...style }}>
      <SupplierLogo logoUrl={logoUrl} size={size} />
    </span>
  );
}
